import { create } from 'zustand'
import { devtools } from 'zustand/middleware'
import toast from 'react-hot-toast'
import { apiFetch } from '../lib/api'

export interface RiskMetric {
  symbol: string
  name: string
  port_api_type: string
  status: 'ok' | 'no_data'
  dataPoints?: number
  annualizedReturn?: number
  volatility?: number
  sharpe?: number | null
  beta?: number | null
  benchmark?: string | null
}

export interface CorrelationEntry {
  symbolA: string
  symbolB: string
  correlation: number
  dataPoints: number
}

export interface RiskResult {
  metrics: RiskMetric[]
  correlations: CorrelationEntry[]
  riskFreeRate: number
  period: string
  calculatedAt: string
}

interface RiskState {
  result: RiskResult | null
  loading: boolean
  compute: (holdings: { symbol: string; name: string; port_api_type: string }[]) => Promise<void>
  clear: () => void
}

export const useRiskStore = create<RiskState>()(
  devtools(
    (set) => ({
      result: null,
      loading: false,

      compute: async (holdings) => {
        set({ loading: true })
        try {
          const res = await apiFetch('/api/risk-analysis', {
            method: 'POST',
            body: JSON.stringify({ holdings }),
          })
          if (!res.ok) throw new Error('Failed')
          set({ result: await res.json() })
        } catch {
          toast.error('คำนวณ Risk Analysis ไม่สำเร็จ')
        } finally {
          set({ loading: false })
        }
      },

      clear: () => set({ result: null }),
    }),
    { name: 'riskStore' }
  )
)
